import { newToolFilterOAuthMcp } from "../oauth.ts";

export const carbonVoiceMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://static.wixstatic.com/shapes/e97c23_633874d233a944aea7b424ae16e9efec.svg",
  url: "https://mcp.carbonvoice.app",
  label: "Carbon Voice",
});
